var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconTwitterSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.813 6.03a.52.52 0 0 0-.208-.904l-.82-.208a.52.52 0 0 1-.343-.727l.457-.924a.52.52 0 0 0-.602-.727l-2.077.582a.52.52 0 0 1-.457-.083 5.192 5.192 0 0 0-8.308 4.154v.373a.26.26 0 0 1-.229.26c-2.918.343-5.712-1.142-8.723-4.61a.53.53 0 0 0-.53-.157.52.52 0 0 0-.301.436 7.87 7.87 0 0 0 .478 5.11.26.26 0 0 1-.27.374L.716 8.75a.52.52 0 0 0-.591.613 5.35 5.35 0 0 0 2.46 3.926.26.26 0 0 1 0 .467l-.55.218a.52.52 0 0 0-.27.717 4.53 4.53 0 0 0 3.324 2.575.26.26 0 0 1 0 .488 11.4 11.4 0 0 1-4.456.862.53.53 0 0 0-.207 1.039 20.8 20.8 0 0 0 8.453 2.004c2.575.04 5.104-.683 7.27-2.077A12.98 12.98 0 0 0 21.923 8.75v-.903a.52.52 0 0 1 .187-.395z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.813 6.03a.52.52 0 0 0-.208-.904l-.82-.208a.52.52 0 0 1-.343-.727l.457-.924a.52.52 0 0 0-.602-.727l-2.077.582a.52.52 0 0 1-.457-.083 5.192 5.192 0 0 0-8.308 4.154v.373a.26.26 0 0 1-.229.26c-2.918.343-5.712-1.142-8.723-4.61a.53.53 0 0 0-.53-.157.52.52 0 0 0-.301.436 7.87 7.87 0 0 0 .478 5.11.26.26 0 0 1-.27.374L.716 8.75a.52.52 0 0 0-.591.613 5.35 5.35 0 0 0 2.46 3.926.26.26 0 0 1 0 .467l-.55.218a.52.52 0 0 0-.27.717 4.53 4.53 0 0 0 3.324 2.575.26.26 0 0 1 0 .488 11.4 11.4 0 0 1-4.456.862.53.53 0 0 0-.207 1.039 20.8 20.8 0 0 0 8.453 2.004c2.575.04 5.104-.683 7.27-2.077A12.98 12.98 0 0 0 21.923 8.75v-.903a.52.52 0 0 1 .187-.395z"
  })));
});
export default SvgIconTwitterSolid;
export const raw = __webpack_public_path__ + "static/media/IconTwitterSolid.f3ec1e51a3b9aba91aa474340b3565da.svg";